import { render } from "./ToastNotification.vue?vue&type=template&id=3b50ddc0"
import script from "./ToastNotification.vue?vue&type=script&lang=js"
export * from "./ToastNotification.vue?vue&type=script&lang=js"

import "./ToastNotification.vue?vue&type=style&index=0&id=3b50ddc0&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__